<template>
    <section class="app-main">
        <div class="title">
            <p @click="$router.go(-1)"><i class="el-icon-back"></i>返回合伙人列表</p>
            <p>用户列表</p>
            <el-input placeholder="输入用户手机号或邮箱" v-model="search" @change="getData()" style="width: 210px; margin-right: 20px" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <el-table :data="tableData" v-loading="table_load" height="580" style="width: 100%">
            
            <el-table-column  prop="user.nickname"   label="姓名"   align="center"></el-table-column>
            <el-table-column  prop="email"    label="邮箱"    align="center" >
                <template slot-scope="scope">
                    <span>{{scope.row.user.email ? scope.row.user.email : '-'}}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="email"    label="手机号"    align="center" >
                <template slot-scope="scope">
                    <span>{{scope.row.user.phone ? scope.row.user.phone : '-'}}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="created_at"    label="绑定时间"   align="center" />
            <el-table-column  prop="created_at"    label="操作"   align="center">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="handleDel(scope.row, scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next, jumper" :current-page.sync="page" style="padding:10px" :total="total"  @current-change="loadPage"></el-pagination>
    </section>
</template>
<script>
import { bind_user_list, bind_user_del } from '@/api/merchant.js'
export default {
    data() {
        return {
            search: '',
            table_load: false,
            page:1,
            total:0,
            tableData:[],
        }
    },
    activated() {
        this.obj = JSON.parse(this.$route.query.obj)
        this.getData()
    },
    methods: {
        getData(){
            let params = { 
                page: this.page,
                user_id: this.obj.user_id,
                agent_id: this.obj.agent_id,
            }
            if(this.search != '') {
                params.keywords = this.search
            }
            this.table_load = true
            bind_user_list( params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }
            }).finally(() => {
                this.table_load = false
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        // 删除
        handleDel(row, i) {
            this.$confirm(`此操作将移除用户： ${row.user.nickname}, 是否继续?`, '提示', {
                type: 'warning'
            }).then(() => {
                bind_user_del(row.id).then(res => {
                    if(res) {
                        this.$message.success('删除成功')
                        this.tableData.splice(i, 1)
                    }
                })
            }).catch(()=>{})
        }
    }
};
</script>
<style scoped lang='less'>
.title {
    margin-left: 10px;
    margin-bottom: 10px;
    p:nth-child(1) {
        text-decoration: underline;
        color: #169bff;
        margin-bottom: 10px;
        cursor: pointer;
    }
    p:nth-child(2) {
        margin-bottom: 10px;
        font-size: 26px;
        font-weight: bold;
        color: #0A1629;
    }
}
</style>